'use strict';

import { Entity } from '../Entity';

export class UserLog extends Entity {
  protected id;

  protected user;

  protected data;

  protected type;

  protected dateTimeCreated;

  protected ind;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.user = data.user;

    this.data = data.data;

    this.type = data.type;

    this.dateTimeCreated = data.dateTimeCreated;

    this.ind = data.ind;
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getUser() {
    return this.user;
  }

  public setUser(user) {
    this.user = user;

    return this;
  }

  public getData() {
    return this.data;
  }

  public setData(data) {
    this.data = data;

    return this;
  }

  public getType() {
    return this.type;
  }

  public setType(type) {
    this.type = type;

    return this;
  }

  public getDateTimeCreated() {
    return this.dateTimeCreated;
  }

  public setDateTimeCreated(dateTimeCreated) {
    this.dateTimeCreated = dateTimeCreated;

    return this;
  }

  public getInd() {
    return this.ind;
  }

  public setInd(ind) {
    this.ind = ind;

    return this;
  }
}
